import { toMetadataAccount } from '../accounts.mjs';
import { MetadataV1GpaBuilder } from '../gpaBuilders.mjs';
import { useOperation } from '../../../types/Operation.mjs';
import { toMetadata } from '../models/Metadata.mjs';

// -----------------
// Operation
// -----------------

const Key = 'FindNftsByUpdateAuthorityOperation';

/**
 * Finds multiple NFTs and SFTs by a given update authority.
 *
 * ```ts
 * const nfts = await metaplex
 *   .nfts()
 *   .findAllByUpdateAuthority({ updateAuthority };
 * ```
 *
 * @group Operations
 * @category Constructors
 */
const findNftsByUpdateAuthorityOperation = useOperation(Key);

/**
 * @group Operations
 * @category Types
 */

/**
 * @group Operations
 * @category Handlers
 */
const findNftsByUpdateAuthorityOperationHandler = {
  handle: async (operation, metaplex, scope) => {
    const {
      updateAuthority
    } = operation.input;
    const gpaBuilder = new MetadataV1GpaBuilder(metaplex, metaplex.programs().getTokenMetadata(scope.programs).address);
    const nfts = await gpaBuilder.whereUpdateAuthority(updateAuthority).get();
    scope.throwIfCanceled();
    return nfts.map(account => {
      if (account == null) {
        return null;
      }
      try {
        return toMetadata(toMetadataAccount(account));
      } catch (error) {
        return null;
      }
    }).filter(nft => nft !== null);
  }
};

export { findNftsByUpdateAuthorityOperation, findNftsByUpdateAuthorityOperationHandler };
//# sourceMappingURL=findNftsByUpdateAuthority.mjs.map
